module.exports = __webpack_public_path__ + "img/circle.cd21cd2b.svg";